<template>
  <div class="color-code">
    <button
      style="background-color: #bf4136"
      @click="seleccion = 'NO SOLVENTE'"
    >
      No solvente
    </button>
    <button
      style="background-color: #bf754b"
      @click="seleccion = 'DOCUMENTOS INCOMPLETOS O ILEGIBLES'"
    >
      Documentos incompletos o ilegibles
    </button>
    <button
      style="background-color: #a69b65"
      @click="seleccion = 'EXCEDE EL PRESUPUESTO'"
    >
      Excede el presupuesto
    </button>

    <button
      style="background-color: #3e442b"
      @click="
        seleccion =
          'NO ACREDITÓ EXPERIENCIA O PERSONAL ADECUADO O CAPACIDAD FINANCIERA'
      "
    >
      No acreditó experiencia o personal adecuado o capacidad financiera
    </button>
    <button style="background-color: #302825" @click="seleccion = 'ND'">
      No especifica
    </button>
  </div>
  <div class="wafle-razones" id="wafle-razones">
    <div id="tooltip-razones" class="tooltip">
      <span class="highlight"> Empresa:</span> {{ empresa_tooltip }} <br />
      <span class="highlight"> Obra:</span> {{ proyecto_tooltip }} <br />
      <span class="highlight">Institución: </span> {{ institucion_tooltip }}
    </div>
    <svg
      id="svg-razones"
      :width="ancho + margenes.derecha + margenes.izquierda"
      :height="alto_wafle"
    >
      <g
        class="grupo-celdas"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
    </svg>
  </div>
</template>

<script setup>
import * as d3 from "d3";
import { ref, onMounted, onUnmounted, watch } from "vue";
import datos from "../assets/data_vis_wafles.json";

const color_dict = ref({
  "NO SOLVENTE": "#BF4136",
  "DOCUMENTOS INCOMPLETOS O ILEGIBLES": "#BF754B",
  "EXCEDE EL PRESUPUESTO": "#A69B65",
  "NO ACREDITÓ EXPERIENCIA O PERSONAL ADECUADO O CAPACIDAD FINANCIERA":
    "#3E442B",
  ND: "#302825",
});
const seleccion = ref("NO SOLVENTE");
const data = ref(datos);
const contenedor_wafle = ref();
const grupo_celdas = ref();
const wafle = ref();
const alto = ref();
const alto_wafle = ref(400);
const ancho = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 20,
  abajo: 5,
  arriba: 20,
});

const numRows = ref(16);
const numCols = ref(10);
const escala_X = ref();
const escala_y = ref();

const tooltip_razones = ref();
const empresa_tooltip = ref();
const proyecto_tooltip = ref();
const institucion_tooltip = ref();

onMounted(() => {
  contenedor_wafle.value = document.getElementById("wafle-razones");
  wafle.value = d3.select(`svg#svg-razones`);
  grupo_celdas.value = wafle.value.select("g.grupo-celdas");
  tooltip_razones.value = d3.select("div#tooltip-razones");
  tooltip_razones.value.style("visibility", "hidden");
  //console.log(data.value);
  dimensiondingWafle();
  dibujandingWafle();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});
watch(seleccion, () => {
  dimensiondingWafle();
  dibujandingWafle();
});

function reescalanding() {
  dimensiondingWafle();
  dibujandingWafle();
}
function dimensiondingWafle() {
  ancho.value =
    contenedor_wafle.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  alto.value = alto_wafle.value - margenes.value.arriba - margenes.value.abajo;

  escala_X.value = d3
    .scaleBand()
    .domain(d3.range(numCols.value))
    .range([0, ancho.value])
    .padding(0.1);

  escala_y.value = d3
    .scaleBand()
    .domain(d3.range(numRows.value))
    .range([alto.value, 0])
    .padding(0.1);
}

function dibujandingWafle() {
  grupo_celdas.value
    .selectAll("rect")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("rect")
          .attr("x", (d) => escala_X.value(d.index_razones % numCols.value))
          .attr("y", (d) =>
            escala_y.value(Math.floor(d.index_razones / numCols.value))
          )
          .attr("width", escala_X.value.bandwidth())
          .attr("height", escala_y.value.bandwidth())
          .attr("fill", (d) => color_dict.value[d.razon_descalificacion])
          .attr("opacity", (d) => {
            if (d.razon_descalificacion == seleccion.value) {
              return 1;
            } else {
              return 0.25;
            }
          })
          .on("mouseover", abrirTooltip)
          .on("mouseleave", cerrarTooltip)
          .on("mousemove", ajustarPosicionTooltip);
      },
      (update) => {
        update
          .transition()
          .attr("x", (d) => escala_X.value(d.index_razones % numCols.value))
          .attr("y", (d) =>
            escala_y.value(Math.floor(d.index_razones / numCols.value))
          )
          .attr("width", escala_X.value.bandwidth())
          .attr("height", escala_y.value.bandwidth())
          .attr("fill", (d) => color_dict.value[d.razon_descalificacion])
          .attr("opacity", (d) => {
            if (d.razon_descalificacion == seleccion.value) {
              return 1;
            } else {
              return 0.25;
            }
          });
      },
      (exit) => {
        exit.remove();
      }
    );
}
function abrirTooltip() {
  let seleccion = d3.select(this).datum();
  //console.log(seleccion);
  proyecto_tooltip.value = seleccion["titulo_expediente_editado 2"];
  institucion_tooltip.value = seleccion["Siglas "];
  empresa_tooltip.value = seleccion["proveedor_editado"];
  tooltip_razones.value.style("visibility", "visible");
}
function cerrarTooltip() {
  tooltip_razones.value.style("visibility", "hidden");
}
function ajustarPosicionTooltip() {
  let position = d3.pointer(event, document.body);
  let x = position[0] - 210;
  let y = position[1] + 20;

  if (x < 0) {
    x = position[0] + 20;
  }

  tooltip_razones.value.style("left", x + "px").style("top", y + "px");
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  border: none;
  color: #ededf3;
  border-radius: 10px;
  box-shadow: 3px 3px 3px #bcbcbf;
  cursor: pointer;
  padding: 12px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.color-code {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
  margin: 15px;
}
.tooltip {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 200px;
  font-size: 14px;
  padding: 5px 5px;
  text-align: left;
}
</style>
